import {useState} from 'react';
import {createProject, updateProject} from '../../../api/project';
import WalletSelect from '../../../components/common/WalletSelect/WalletSelect';

const CreateProjectForm = ({project, companies, onCreated, onCancel}) => {
    const [title, setTitle] = useState(project?.title ?? '');
    const [companyId, setCompanyId] = useState(project?.companyId ? String(project.companyId) : '');
    const [description, setDescription] = useState(project?.description ?? '');
    const [startDate, setStartDate] = useState(project?.startDate ?? '');
    const [endDate, setEndDate] = useState(project?.endDate ?? '');
    const [saving, setSaving] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        setSaving(true);
        const body = {
            title,
            companyId: companyId ? Number(companyId) : null,
            description: description || null,
            startDate,
            endDate: endDate || null,
        };
        const request = project ? updateProject(project.id, body) : createProject(body);
        request.then(onCreated).finally(() => setSaving(false));
    };

    return (
        <form className="create-form" onSubmit={submit}>
            <h4 className="create-form__title">{project ? 'Edit Project' : 'New Project'}</h4>
            <div className="create-form__field">
                <label className="create-form__label">Title</label>
                <input className="create-form__input" value={title} onChange={e => setTitle(e.target.value)} required autoFocus/>
            </div>
            <div className="create-form__field">
                <label className="create-form__label">Company <span className="create-form__optional">(optional)</span></label>
                <WalletSelect
                    options={companies.map(c => ({value: String(c.id), label: c.name}))}
                    value={companyId ? {value: companyId, label: companies.find(c => String(c.id) === companyId)?.name ?? ''} : null}
                    onChange={opt => setCompanyId(opt?.value ?? '')}
                    placeholder="— none —"
                    isClearable={true}
                />
            </div>
            <div className="create-form__field">
                <label className="create-form__label">Description <span className="create-form__optional">(optional)</span></label>
                <textarea className="create-form__input create-form__textarea" value={description} onChange={e => setDescription(e.target.value)} rows={2}/>
            </div>
            <div className="create-form__row">
                <div className="create-form__field">
                    <label className="create-form__label">Start date</label>
                    <input className="create-form__input" type="date" value={startDate} onChange={e => setStartDate(e.target.value)} required/>
                </div>
                <div className="create-form__field">
                    <label className="create-form__label">End date <span className="create-form__optional">(optional)</span></label>
                    <input className="create-form__input" type="date" value={endDate} onChange={e => setEndDate(e.target.value)}/>
                </div>
            </div>
            <div className="create-form__actions">
                <button type="button" className="create-form__btn" onClick={onCancel}>Cancel</button>
                <button type="submit" className="create-form__btn create-form__btn--primary" disabled={saving || !title.trim() || !startDate}>
                    {saving ? 'Saving…' : project ? 'Save' : 'Create'}
                </button>
            </div>
        </form>
    );
};

export default CreateProjectForm;